import React from "react";

const DangerIcon = React.memo(() => {
	return (
		<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_284_299331)">
				<path
					d="M8.40039 0.75L15.9004 14H0.900391L8.40039 0.75ZM8.40564 12.5C8.69964 12.5 9.01464 12.1587 9.01464 11.7555C9.01464 11.3313 8.69964 11 8.40564 11C8.03789 11 7.78589 11.3313 7.78589 11.7555C7.78614 12.1587 8.03814 12.5 8.40564 12.5ZM8.65039 10.25C8.65039 10.25 8.86914 8.65825 8.90039 8.124C8.94589 7.3455 8.90039 5.005 8.90039 5.005H7.90039C7.90039 5.005 7.85489 7.3455 7.90039 8.124C7.93164 8.65825 8.15039 10.25 8.15039 10.25H8.65039Z"
					fill="#B02B2B"
				/>
			</g>
			<defs>
				<clipPath id="clip0_284_299331">
					<rect width="16" height="16" fill="white" transform="translate(0.400391)" />
				</clipPath>
			</defs>
		</svg>
	);
});

export default DangerIcon;
